'use client'

import { useEffect, useRef } from 'react';
import styled from 'styled-components';

const Main = styled.main`
  height: 100vh;
  overflow-y: hidden;

  iframe {
    height: 100vh;
    border: none;
    
    &.allow-scrolling {
      overflow: auto !important;
    }
  }
`

const Subscribe = () => {
  const iFrameRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if(iFrameRef?.current) {
      iFrameRef.current.classList.add("allow-scrolling");
      iFrameRef.current.setAttribute("scrolling", "yes");
    }
  }, [])
  
  return (
    <Main>
      <iframe ref={iFrameRef} src="https://manage.kmail-lists.com/subscriptions/subscribe?a=Yrca4a&g=RfyLqS&embed=1" seamless width="100%" />
    </Main>
  )
}

export default Subscribe;